enum ZoomType {
  Basic = 1,
  Pro = 2,
  OnPrem = 3,
  None = 99,
}

export default ZoomType;
